<template>
  <div id="bg"  :style="{width: width + 'px', height: height + 'px'}">
    <img src="../assets/img/login_bg.png"  class="img" draggable="false">
    <img src="../assets/img/background.svg"  class="img" draggable="false">
    <div style="position: fixed; left: 25px;top:17px;z-index: 1;height: 40px;line-height: 40px;color: #FFF;font-size: 23px;letter-spacing: 2px;">
      <span>&nbsp;青岛青春足球场数据监控后台系统</span>
    </div>
    <div  :style="{'top': '150px'}" style="position: fixed;width: 100%;z-index: 999;">
      <div style="margin: 0 auto;height: 500px;max-width: 800px;background: transparent;">
        <lay-row >
          <lay-col md="12" sm="12" xs="0" v-show="width > 768">
            <img  src="../assets/img/login_bg_left.png" style="height:500px;width: auto" draggable="false"/>
          </lay-col>
          <lay-col md="12" sm="12" xs="18" xs-offset="3">
            <div style="height: 500px;background: #FFF;" :style="{'border-radius': width > 768 ? '0 10px 10px 0' : '10px'}">
              <div style="padding: 70px 20px 0">
                <lay-space direction="vertical" fill wrap :size="['35px', '0px']">
                  <h3 style="text-align: center;letter-spacing: 2px; font-size: 20px;color: #666;padding: 10px;font-weight: bold">青岛青春足球场数据监控后台系统</h3>
                  <lay-input suffix-icon="layui-icon-username" v-model="info.username" placeholder="请输入用户名"  @keyup.enter="login" :allow-clear="true" autofocus :maxlength="10">
                    <template #prepend>用户名</template>
                  </lay-input>
                  <lay-input suffix-icon="layui-icon-password" v-model="info.password" placeholder="请输入密码"  @keyup.enter="login"  :allow-clear="true" :password="true" type="password" :maxlength="20">
                    <template #prepend>密 <span style="color: transparent">占</span> 码</template>
                  </lay-input>
                  <lay-button border="blue" fluid="true" :loading="loading" loadingIcon="layui-icon-loading" @click="login">登录</lay-button>
                </lay-space>
              </div>
            </div>
          </lay-col>
        </lay-row>

      </div>
    </div>
  </div>
</template>

<script setup>
import {useSize} from "@/assets/js/size";
import { ref} from "vue";
import {layer} from "@layui/layui-vue";
import axios from "axios";
import {useRouter} from "vue-router/dist/vue-router";
const {width, height} = useSize()
const loading = ref(false);
const router = useRouter()
const info = ref({
  username: '',
  password: ''
})

const msg = (info) =>  layer.msg(info, { icon : 3, time: 1000, zIndex: 9999999999})

const login = () => {
  if (loading.value){
    msg("登录中，请稍后。")
    return;
  }
  const {username, password} = info.value;
  if (!username || !password){
    msg("用户名或密码为空")
    return
  }
  loading.value = true
  axios.post("/login", info.value)
      .then(function (response) {
        let success = response.data.code == 0;
        if (success){
            setTimeout(() => {
              localStorage.setItem("access_token", response.data.data)
              router.push({path: "/1", replace: true})
            }, 500)
        }
        msg(response.data.msg)
      })
      .catch(function () {
        msg("数据请求异常，请稍后重试")
      }).finally(() => {
          loading.value = false
      });
}



</script>
<style scoped>
.img{
  position: fixed;
  left: 0;
  top:0;
  width: 100%;
  height: 100%;
}
</style>